import { Box, Typography } from '@mui/material';
export function BlueprintArtwork({
  title,
  image,
  large = false,
}: {
  title: string;
  image?: string | null;
  large?: boolean;
}) {
  const hue = ([...title].reduce((n, c) => n + c.charCodeAt(0), 0) % 80) + 155;
  return (
    <Box
      className="blueprint-art"
      sx={{ height: large ? 240 : 160, '--blueprint-hue': hue }}
    >
      {image ? (
        <img src={image} alt={`${title} blueprint`} loading="lazy" />
      ) : (
        <>
          <Box className="blueprint-art__label">
            <span>SV / BLUEPRINT</span>
            <span>● ● ●</span>
          </Box>
          <Box className="blueprint-art__signal" aria-hidden="true">
            {Array.from({ length: 38 }, (_, i) => (
              <i key={i} style={{ height: `${18 + ((i * 17 + hue) % 65)}%` }} />
            ))}
          </Box>
          <Box className="blueprint-art__modules" aria-hidden="true">
            {['INPUT', 'SHAPE', 'SPACE', 'OUTPUT'].map((label, i) => (
              <div key={label}>
                <b style={{ transform: `rotate(${i * 55 - 80}deg)` }} />
                <span>{label}</span>
              </div>
            ))}
          </Box>
          <Typography className="blueprint-art__serial">
            BP / {String(hue).padStart(3, '0')}
          </Typography>
        </>
      )}
    </Box>
  );
}
